import {
  SearchRsvpsResponse,
  CursorSearch,
  SearchRsvpsOptions,
} from './src/events-v2-rsvp-rsvp-v-2.universal';

export * from './src/events-v2-rsvp-rsvp-v-2.universal.js';

/** @hidden */
export type RsvpSearch = {};

/**
 * Retrieves a list of RSVPs that match the specified search query and optionally performs aggregations on the data queried.
 *
 * To learn about working with _search_, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language), [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging), and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 * @param search - Search options. See [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language) for more details.
 * @public
 * @requiredField search
 * @permissionId WIX_EVENTS.READ_RSVP
 * @applicableIdentity APP
 * @fqn wix.events.rsvps.v2.RsvpManagement.SearchRsvps
 */
export declare function searchRsvps(
  search: CursorSearch,
  options: SearchRsvpsOptions
): Promise<SearchRsvpsResponse>;
